"use client";

/**
 * Service Worker boot — TEMPORALMENTE DESACTIVADO.
 *
 * Estado: KILL-SWITCH activo. No registra `/sw.js` y, además, desregistra
 * activamente cualquier SW previo + limpia todos los caches de la app.
 * Esto rompe el ciclo en el que un SW v8 viejo seguía sirviendo bundle
 * JS roto (errores #418/#423 de hidratación) aunque el deploy fuera nuevo.
 *
 * Para reactivar: poner `OFFLINE_DISABLED = false` y volver a buildear.
 */

import { useEffect } from "react";

// Reactivado: el SW ahora es Serwist (precache ATÓMICO por build — ver
// app/sw.ts y next.config.mjs), ya no es el kill-switch hand-made que causó
// #418/#423. ⚠️ Solo debe llegar a producción tras QA en dispositivo (modo
// avión): el cold-start offline dentro del WebView solo se valida ahí.
const OFFLINE_DISABLED = false;
const SW_URL = "/sw.js";

function dispatchUpdateEvent(reg: ServiceWorkerRegistration) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("cacique:sw-update", { detail: reg }));
}

async function killAllServiceWorkers() {
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister().catch(() => false)));
  } catch { /* ignore */ }
  try {
    if (typeof caches !== "undefined") {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k).catch(() => false)));
    }
  } catch { /* ignore */ }
}

export default function ServiceWorkerBoot() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;

    // KILL-SWITCH: desregistrar todo y no registrar nada nuevo.
    if (OFFLINE_DISABLED) {
      killAllServiceWorkers();
      return;
    }

    // En dev evitamos registrar el SW para no cachear assets de Next.js HMR.
    if (process.env.NODE_ENV !== "production") return;

    let cancelled = false;

    const register = async () => {
      try {
        const reg = await navigator.serviceWorker.register(SW_URL, { scope: "/" });
        if (cancelled) return;

        try { await reg.update(); } catch { /* ignore */ }

        if (reg.waiting) {
          if (navigator.serviceWorker.controller) {
            dispatchUpdateEvent(reg);
          } else {
            reg.waiting.postMessage({ type: "SKIP_WAITING" });
          }
        }

        let refreshing = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          setTimeout(() => window.location.reload(), 100);
        });

        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed") {
              if (navigator.serviceWorker.controller) {
                dispatchUpdateEvent(reg);
              } else {
                installing.postMessage({ type: "SKIP_WAITING" });
              }
            }
          });
        });
      } catch {
        /* sin SW seguimos online-only sin caché */
      }
    };

    register();
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}
